import { DropdownControl, FormCol, FormRow } from 'ia-react-core';
import React, { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Assignments } from '../../../../../interfaces/Assignments';
import useDefaultValue from '../../useDefaultValue';

export interface AssignmentsRowProps { assignments: Assignments[] }

const AssignmentsRow: FC<AssignmentsRowProps> = ({ assignments }) => {
  const { t } = useTranslation('NewMessagePage');
  const assignmentsOptions = useMemo(() => assignments.map((a) => ({
    label: a.name,
    value: a.id,
  })), [assignments]);

  const defaultValue = useDefaultValue('defaultassignment', assignmentsOptions, false);

  return (
    <FormRow>
      <FormCol label={t('assignments')} labelMarginBottom={36}>
        <DropdownControl
          name="subjectAssignment"
          aria-label={t('assignments')}
          options={assignmentsOptions}
          defaultValue={defaultValue}
        />
      </FormCol>

    </FormRow>
  );
};
export default AssignmentsRow;
